import { AxiosResponse } from 'axios';
import {
  ICompany,
  ICompanyRegisterDTO,
} from '../shared/interfaces/company-interfaces';
import api from './api';

interface IService {
  create: (data: ICompanyRegisterDTO) => Promise<ICompany>;
  update: (id: string, data: Partial<ICompanyRegisterDTO>) => Promise<any>;
  detail: (slug: string) => Promise<AxiosResponse<ICompany>>;
  listServicesBySlug: (slug: string) => Promise<AxiosResponse<IService[]>>;
}

const companyService: IService = {
  create: (data: ICompanyRegisterDTO) =>
    api.post('/company/register_company', data),
  update: (id: string, data: Partial<ICompanyRegisterDTO>) =>
    api.patch(`/company/update_company/${id}`, data),
  detail: (slug: string) => api.get(`/company/retrieve_company/${slug}`),
  listServicesBySlug: (slug: string) =>
    api.get(`/company/list_services/${slug}`),
};

export default companyService;
